import styled, { css } from "styled-components";

export const Title = styled.div`
  ${({ theme }) => css`
    font-size:  ${theme?.fonts?.fontSize?.pageTitle ?? "24px"} ;
    color: ${theme?.colour?.secondary ?? "#04333b"};
    font-weight:  ${theme?.fonts?.fontWeight?.pageTitle ?? "600"};
  `}
`;
